import { BaseEntity } from './BaseEntity';
import { IBaseEntry } from './interfaces/IBaseEntry';

export class BaseDocument extends BaseEntity implements IBaseEntry{
    code?: string;
    name?: string;
    stateId?: string;
}